import { useContext, useState } from "react";
import { fetchApi } from "../../../../DataApi/fetchApi";
import { CartContext } from "../../../../contexts/MiniStore/CartContext";
import { useNavigate } from "react-router-dom";

function usePaymentResponse() {
  const navigate = useNavigate();
  const [transactionDetail, setTransactionDetail] = useState(null);
  const { handleResetCart } = useContext(CartContext);
  const handlePaymentRedirectMethod = async (str, isThawaniMethod) => {
    if (!str) {
      return null;
    }
    let url = "";
    let thawaniURL = "";
    let formData = new FormData();
    let payload = {};
    const div = document.createElement("div");
    div.innerHTML = str;
    [...div.getElementsByTagName("input")].map((inp) => {
      const name = inp.getAttribute("name");
      if (name === "data_set") {
        url = inp.getAttribute("data-action-url");
      } else {
        if (isThawaniMethod) {
          thawaniURL = inp.getAttribute("value") || "";
        }

        formData.append(name, inp.getAttribute("value") || "");
        payload = { ...payload, [name]: inp.getAttribute("value") || "" };
      }
    });
    if (isThawaniMethod) {
      window.location.href = thawaniURL;
    } else {
      try {
        const resp = await fetch(`${window.location.origin}${url}`, {
          body: formData,
          method: "POST",
        });
        // console.log(resp, "response of the request for redirect");
        if (resp?.url) {
          window.location.href = resp.url;
        }
      } catch (error) {
        console.error("Error while Redirecting Transaction", error.message);
      }
    }

    // handlePaymentPoll();
  };
  const handlePaymentPoll = async () => {
    const raw = JSON.stringify({
      jsonrpc: "2.0",
      method: "call",
      params: {},
    });

    try {
      const myHeaders = new Headers();
      myHeaders.append("X-Requested-With", "XMLHttpRequest");
      myHeaders.append(
        "Accept",
        "application/json, text/javascript, */*; q=0.01"
      );
      myHeaders.append("Content-Type", "application/json");
      const endpoint = "/payment/process/poll";
      const pollResp = await fetch(`${window.location.origin}${endpoint}`, {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      });

      let response = await pollResp.text();
      response = JSON.parse(response);

      if (response?.result?.success) {
        handleResetCart();
        setTransactionDetail(response?.result?.transactions?.[0]);
      } else {
        setTimeout(() => {
          handlePaymentPoll();
        }, 1000);
      }

      // console.log(response, "pollingResponse");
    } catch (error) {
      console.error("Polling request failed", error);
    } finally {
    }
  };

  return {
    handlePaymentRedirectMethod,
    handlePaymentPoll,
    transactionDetail,
  };
}

export default usePaymentResponse;
